import React from 'react'

export default function Footer(props) {
  return (
    <div className={props.className} id="footer">
      <a href="https://www.instagram.com/drumminup" target="_blank" rel="noopener noreferrer">A Drummin Up Product</a>
    </div>
  )
}
